module.exports = __webpack_public_path__ + "static/media/infrared-scan.eed4f906.jpg";